import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, Container, Row, Col, FormGroup, Input, Form } from 'reactstrap';
import useApi from 'vl-common/src/hooks/useApi';
import { AlertMessage } from 'vl-common/src/components/AlertMessage/AlertMessage';
import { LoadingButton } from 'vl-common/src/components/LoadingButton';
import { tools } from 'vl-common/src/lib/service.tools';

const AddNote = (props) => {
  const { t } = useTranslation('common');
  const { Api } = useApi();
  const { close, data } = props;
  const [modal, setModal] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [loading_create, setLoading_create] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState({
    visibility: false,
    msg: ''
  });
  //data
  const [note, setNote] = useState('');

  const toggle = () => {
    setModal(false);
    close();
    setNote('');
    setLoading_create(false);
  };

  useEffect(() => {
    if (props.show) {
      //load data
    }
    setModal(props.show || false);

    if (props.isAddMode) {
      //add mode
      setIsAddMode(true);
      setNote('');
    } else {
      //Edit mode here
      setIsAddMode(false);
    }
  }, [props.show]);

  const displayAlertMessage = (msg = '') => {
    setShowAlertMessage({ visibility: true, msg });
    const t = setTimeout(() => {
      setShowAlertMessage({ visibility: false, msg });
      clearTimeout(t);
    }, 7000);
  };

  const createNote = (data) => {
    Api.notes
      .createNotes({
        ...data
      })
      .then((res) => {
        setLoading_create(false);
        if (props.onCreated) {
          props.onCreated('Add');
        }
      })
      .catch((e) => {
        if (e?.response?.status) {
          const status = e.response.status;
          displayAlertMessage(`Error-${status}`);
        }
        setLoading_create(false);
      });
  };

  const createHandler = () => {
    if (!isFormValid()) return;
    setLoading_create(true);

    if (isAddMode) {
      //---add mode
      const default_data = {
        case_id: data.case_id,
        note_text: note,
        clin_visible: true
      };
      createNote(default_data);
    } else {
      //---edit mode
      setLoading_create(false);
    }
  };

  const isFormValid = () => {
    if (tools.isEmptyOrNull(note)) {
      displayAlertMessage('Please enter your notes');
      return false;
    }
    return true;
  };

  return (
    <div>
      <Modal
        centered
        className="vl-add-modal"
        size={'xl'}
        isOpen={modal}
        toggle={toggle}
        backdrop={'static'}
        keyboard={false}
        data-testid="add-note-modal"
      >
        <ModalBody className="p-5 vl-addNote">
          <Container fluid={true}>
            <Row>
              <AlertMessage message={showAlertMessage.msg} visibility={showAlertMessage.visibility} />
              <Col xs="12" className="text-center">
                <span className="vl-modal-title">
                  <span className="vl-product-pink">{isAddMode ? t('Add') : t('Edit_2')}</span>
                  <span className="vl-gray ">{t('Note')}</span>
                </span>
              </Col>
              <br />
              <Col xs="12">
                <Form className="mt-3">
                  <input type="hidden" value="something" />
                  <Row>
                    <Col xs="12">
                      <FormGroup>
                        <Input
                          type="textarea"
                          className="input-box"
                          placeholder={t('Enter your notes here')}
                          data-testid="note-input"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12" className="text-center">
                      <Button
                        className="vl-button-gray vl-font-regular"
                        type="button"
                        onClick={toggle}
                        data-testid="cancel-add-note-modal-button"
                      >
                        {t('Cancel')}
                      </Button>
                      <LoadingButton
                        className="vl-button vl-font-regular min-width"
                        onClick={createHandler}
                        loading={loading_create}
                        disabled={loading_create}
                        data-testid="save-note-button"
                      >
                        {loading_create ? t('Saving...') : t('Save')}
                      </LoadingButton>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export { AddNote };
